"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsConfirmation = void 0;
var react_1 = __importDefault(require("react"));
var mappings_1 = require("../../../../shared/api/mappings");
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var components_1 = require("../../components");
var copy_1 = require("../../copy");
var section_ids_1 = require("../../section-ids");
var utils_1 = require("../../utils");
var ui_1 = require("../MeterReadings/ui");
var ui_2 = require("./ui");
exports.MeterReadingsConfirmation = (0, core_1.withCustomerAndAccountIds)(function (_a) {
    var _b;
    var accountId = _a.accountId;
    var ErrorSection = (0, core_1.useComponents)().ErrorSection;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var urlSearchParams = new URLSearchParams(window.location.search);
    var fuel = urlSearchParams.get('fuel');
    var _c = (0, mappings_1.useMeterReads)(accountId), data = _c.data, loading = _c.loading, error = _c.error;
    if (loading) {
        return react_1.default.createElement(components_1.PageLoading, null);
    }
    if (error) {
        return react_1.default.createElement(components_1.Error, null);
    }
    if (!data) {
        return (react_1.default.createElement(components_1.NoDataError, { heading: react_1.default.createElement(Copy, { copyKey: "meterReadsHeading" }), "data-testid": 'kapi-meter-reads-info-error' }));
    }
    return (react_1.default.createElement(ui_1.MeterReadingsPage, { name: analytics_subjects_1.METER_READINGS_SUCCESSFUL_SUBMIT, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b[analytics_subjects_1.KAPI_ONLY] = true, _b), supplies: data }, (0, utils_1.hasRequiredSearchParams)(urlSearchParams) ? (react_1.default.createElement(ui_2.MeterReadingsConfirmationUI, { searchParams: urlSearchParams, supplies: data, fuel: fuel })) : (react_1.default.createElement(ErrorSection, { id: section_ids_1.METER_READ_PAGE_ERROR }))));
});
